import type { RoundScore } from '@/types/dde/teamHoleByHole.types'

import { GolfHoleScore, HoleByHoleRowItem, TotalScores as TotalScoresStyled } from './styles'
import { EMPTY_VALUE } from './utils'

interface TotalScoresProps {
  rowData: RoundScore | null
}

export const TotalScores = ({ rowData }: TotalScoresProps) => {
  return (
    <TotalScoresStyled>
      <HoleByHoleRowItem>
        <GolfHoleScore>
          {rowData && 'roundPar' in rowData ? rowData.roundPar.displayValue : EMPTY_VALUE}
        </GolfHoleScore>
      </HoleByHoleRowItem>
      <HoleByHoleRowItem>
        <GolfHoleScore>
          {rowData && 'roundScore' in rowData ? rowData.roundScore.displayValue : 0}
        </GolfHoleScore>
      </HoleByHoleRowItem>
    </TotalScoresStyled>
  )
}
